// components/shared/categories/CategoriesList.tsx
"use client"

import { HorizontalScroll } from "../../ui/HorizontalScroll";
import { CategoryCard } from "./CategoryCard";
import { Category } from "@cabukaka/types";

interface CategoriesListProps {
  categories: Category[];
  layout?: 'horizontal-list' | 'grid'
}


export function CategoriesList({ categories, layout = "horizontal-list" }: CategoriesListProps) {


  if (layout === "grid") {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {categories.map((category, idx) => (
          <CategoryCard key={idx} category={category} />
        ))}
      </div>
    )
  }
  return (
    <HorizontalScroll>
      {(categories || []).map((category, idx) => (
        <CategoryCard
          key={idx}
          category={category}
        />
      ))}
    </HorizontalScroll>
  );
}